<template>
  <div class="mission-top-page">
    <header-pane
      :hasHeaderNav="true"
      :pageTitle="'MISSION'"
      navigationCurrent="mission"
      colorType="light"
    />
    <div class="mission-top-page__contents">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onUnmounted } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import StoreUtil from '@/store/StoreUtil'

/**
 * ミッションページ
 */
export default defineComponent({
  name: 'MissionTopPage',
  components: { HeaderPane },
  setup() {
    const missionPageStore = StoreUtil.useStore('MissionPageStore')
    const { clearMissionPageData } = missionPageStore
    onUnmounted(() => {
      clearMissionPageData()
    })
  },
})
</script>

<style scoped lang="scss">
.mission-top-page {
  display: flex;
  flex-direction: column;
  height: var(--screen-height);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: $black20;

  &__contents {
    flex-grow: 1;
    overflow-y: auto;
  }
}
</style>
